import * as Basic$SolvuuApi0 from "solvuu-api0/./basic.bs.js";
import * as Basic_ping_request_bs$SolvuuApi0 from "solvuu-api0/./basic_ping_request_bs.bs.js";
import * as Basic_ping_response_bs$SolvuuApi0 from "solvuu-api0/./basic_ping_response_bs.bs.js";
import * as Basic_ping_response_atd$SolvuuApi0 from "solvuu-api0/./basic_ping_response_atd.bs.js";
var entity = Basic$SolvuuApi0.entity;
var $$let = Basic$SolvuuApi0.Ping.$$Request;
var Ping_entity = Basic$SolvuuApi0.Ping.entity;
var Ping_service = Basic$SolvuuApi0.Ping.service;
var Ping_Request = {
  Json: Basic_ping_request_bs$SolvuuApi0,
  json_of_info: $$let.json_of_info,
  info_of_json: $$let.info_of_json,
  path: $$let.path,
  body: $$let.body,
  info: $$let.info
};
var Ping_Response = {
  Json: Basic_ping_response_bs$SolvuuApi0,
  json_of_ok: Basic_ping_response_atd$SolvuuApi0.json_of_ok,
  json_of_bad_request: Basic_ping_response_atd$SolvuuApi0.json_of_bad_request,
  json_of_not_found: Basic_ping_response_atd$SolvuuApi0.json_of_not_found,
  ok_of_json: Basic_ping_response_atd$SolvuuApi0.ok_of_json,
  bad_request_of_json: Basic_ping_response_atd$SolvuuApi0.bad_request_of_json,
  not_found_of_json: Basic_ping_response_atd$SolvuuApi0.not_found_of_json
};
var Ping = {
  entity: Ping_entity,
  service: Ping_service,
  $$Request: Ping_Request,
  $$Response: Ping_Response
};
export { entity, Ping };
/* Basic_ping_response_bs-SolvuuApi0 Not a pure module */